exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".readonly-value[data-v-5e1a8820]{color:#606266;font-size:13px}.upload-demo[data-v-5e1a8820]  .el-upload__tip{margin-top:4px;line-height:1.4}.dialog-footer[data-v-5e1a8820]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;gap:8px}", ""]);

// exports
